import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/suppliers', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/suppliers/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, supplierData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/suppliers', supplierData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, supplierData) {
      return new Promise((resolve, reject) => {
        const url = `/suppliers/${supplierData.id}`
        axios
          .put(url, supplierData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/suppliers/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
